/**
 * @generated SignedSource<<21d5dbd63af76e2871a566c14b44f537>>
 * @relayHash 3675a406b50de7305e4c6e3b8d584ef9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8d936a5a703f81531300d690c6ccc016111e16d679d1c282b20a4d71d8246e24

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SolutionComposerDataProviderV2Query } from './SolutionComposerDataProviderV2Query.graphql';

const node: PreloadableConcreteRequest<SolutionComposerDataProviderV2Query> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8d936a5a703f81531300d690c6ccc016111e16d679d1c282b20a4d71d8246e24",
    "metadata": {},
    "name": "SolutionComposerDataProviderV2Query",
    "operationKind": "query",
    "text": null
  }
};

export default node;
